import { render } from "./NLPanel.vue?vue&type=template&id=7c8aabf7&scoped=true&ts=true"
import script from "./NLPanel.vue?vue&type=script&lang=ts"
export * from "./NLPanel.vue?vue&type=script&lang=ts"

import "./NLPanel.vue?vue&type=style&index=0&id=7c8aabf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8aabf7"]])

export default __exports__